import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _Number$MAX_SAFE_INTEGER from "@babel/runtime-corejs3/core-js-stable/number/max-safe-integer";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof _Object$getOwnPropertySymbols === "function") for (var i = 0, p = _Object$getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React, { useContext, useState, useEffect, useCallback, useRef } from 'react';
import classNames from 'classnames';
import ConfigContext from '../config-provider/ConfigContext';
import { getCompProps } from '../_utils';
import ClearableInput from './ClearableLabeledInput';
import { BorderTypes, fixControlledValue } from './input';
import calculateNodeHeight from './calculateNodeHeight';
import { useResizeObserver, useMergedState } from '../_utils/hooks';
import devWarning from '../_utils/devwarning';

var InternalTextarea = function InternalTextarea(props, ref) {
  var thisTextareaRef = useRef();
  var textareaRef = ref || thisTextareaRef;

  var _useContext = useContext(ConfigContext),
      getPrefixCls = _useContext.getPrefixCls,
      prefixCls = _useContext.prefixCls,
      userDefaultProps = _useContext.compDefaultProps;

  var textAreaProps = getCompProps('TextArea', userDefaultProps, props); // 按钮属性需要合并一遍用户定义的默认属性

  var _useState = useState({}),
      _useState2 = _slicedToArray(_useState, 2),
      textareaStyles = _useState2[0],
      setTextareaStyles = _useState2[1];

  var propsValue = textAreaProps.value,
      allowClear = textAreaProps.allowClear,
      borderType = textAreaProps.borderType,
      defaultValue = textAreaProps.defaultValue,
      count = textAreaProps.count,
      autoSize = textAreaProps.autoSize,
      className = textAreaProps.className,
      customPrefixcls = textAreaProps.prefixCls,
      canResize = textAreaProps.canResize,
      maxLength = textAreaProps.maxLength,
      disabled = textAreaProps.disabled,
      onBlur = textAreaProps.onBlur,
      onFocus = textAreaProps.onFocus,
      onChange = textAreaProps.onChange,
      placeholder = textAreaProps.placeholder,
      style = textAreaProps.style,
      size = textAreaProps.size,
      others = __rest(textAreaProps, ["value", "allowClear", "borderType", "defaultValue", "count", "autoSize", "className", "prefixCls", "canResize", "maxLength", "disabled", "onBlur", "onFocus", "onChange", "placeholder", "style", "size"]);

  var textAreaPrefixCls = getPrefixCls(prefixCls, 'input', customPrefixcls); // TextArea样式前缀

  devWarning(BorderTypes.indexOf(borderType) === -1, 'textarea', "cannot found textarea borderType '".concat(borderType, "'"));

  var _useMergedState = useMergedState('', {
    value: propsValue,
    defaultValue: defaultValue
  }),
      _useMergedState2 = _slicedToArray(_useMergedState, 2),
      value = _useMergedState2[0],
      setValue = _useMergedState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      showNumberMark = _useState4[0],
      setShowNumberMark = _useState4[1];

  var resizeTextarea = useCallback(function () {
    if (!autoSize || !textareaRef.current) {
      return;
    }

    var minRows = autoSize.minRows,
        maxRows = autoSize.maxRows;
    var textareaStyles = calculateNodeHeight(textareaRef.current, minRows, maxRows);

    if (style) {
      var height = style.height || _Number$MAX_SAFE_INTEGER;
      var maxHeight = style.maxHeight || _Number$MAX_SAFE_INTEGER;

      if (Math.min(height, maxHeight) > textareaStyles.height) {
        textareaStyles.overflowY = 'hidden';
      } else {
        textareaStyles.overflowY = '';
      }
    }

    setTextareaStyles(textareaStyles);
  }, [autoSize, textareaRef, style]);
  useResizeObserver(textareaRef.current, resizeTextarea);

  var handleChange = function handleChange(e) {
    if (value === undefined) return;
    setValue(e.target.value);
    onChange && onChange(e);
  };

  var handleFocus = function handleFocus(e) {
    !showNumberMark && setShowNumberMark(true);
    onFocus && onFocus(e);
  };

  var handleBlur = function handleBlur(e) {
    showNumberMark && setShowNumberMark(false);
    onBlur && onBlur(e);
  };

  var handleReset = function handleReset() {
    setValue('');
    var event = {
      target: {
        value: ''
      }
    };

    if (textareaRef.current) {
      textareaRef.current.value = '';
      textareaRef.current.focus();
      event.target = textareaRef.current;
    }

    onChange && onChange(event);
  };

  var renderNumberMark = function renderNumberMark() {
    var enteredLength = value ? value.length : 0;

    if (enteredLength >= maxLength) {
      enteredLength = maxLength;
    }

    if (count && showNumberMark && !disabled && maxLength !== '' && maxLength >= 0) {
      return /*#__PURE__*/React.createElement("div", {
        className: "".concat(textAreaPrefixCls, "-textarea-mark")
      }, enteredLength, "/", maxLength);
    }

    return null;
  };

  useEffect(function () {
    resizeTextarea();
  }, [value, resizeTextarea]);
  useEffect(function () {
    if (propsValue !== undefined) {
      setValue(propsValue);
    }
  }, [propsValue, setValue]);

  var renderTextArea = function renderTextArea(prefixCls) {
    var _context, _classNames, _context2;

    var hadCount = count && !disabled && !allowClear;

    var _a = style || {},
        width = _a.width,
        margin = _a.margin,
        marginLeft = _a.marginLeft,
        marginRight = _a.marginRight,
        marginTop = _a.marginTop,
        marginBottom = _a.marginBottom,
        otherStyles = __rest(_a, ["width", "margin", "marginLeft", "marginRight", "marginTop", "marginBottom"]);

    var wrapperStyle = style ? {
      width: width,
      margin: margin,
      marginLeft: marginLeft,
      marginRight: marginRight,
      marginTop: marginTop,
      marginBottom: marginBottom
    } : {};

    for (var key in wrapperStyle) {
      if (wrapperStyle[key] === undefined) {
        delete wrapperStyle[key];
      }
    }

    var textarea = /*#__PURE__*/React.createElement("textarea", _extends({
      ref: textareaRef,
      disabled: disabled,
      style: _extends({}, textareaStyles, hadCount || !!allowClear ? otherStyles : style),
      className: classNames("".concat(prefixCls, "-textarea"), (_classNames = {}, _defineProperty(_classNames, _concatInstanceProperty(_context = "".concat(prefixCls, "-size-")).call(_context, size), size), _defineProperty(_classNames, "".concat(prefixCls, "-borderless"), borderType === 'none'), _defineProperty(_classNames, "".concat(prefixCls, "-underline"), borderType === 'underline'), _defineProperty(_classNames, "".concat(prefixCls, "-disabled"), disabled), _defineProperty(_classNames, "".concat(prefixCls, "-no-resize"), canResize !== true), _defineProperty(_classNames, "".concat(prefixCls, "-allowClear-spacing"), !!allowClear), _classNames), _defineProperty({}, className, className && !allowClear && !hadCount)),
      onChange: handleChange,
      onFocus: !disabled ? handleFocus : undefined,
      onBlur: !disabled ? handleBlur : undefined,
      value: fixControlledValue(value),
      placeholder: placeholder,
      maxLength: maxLength
    }, others));
    return hadCount ? /*#__PURE__*/React.createElement("span", {
      style: wrapperStyle,
      className: _concatInstanceProperty(_context2 = "".concat(prefixCls, "-countWrapper ")).call(_context2, className && !allowClear ? className : '')
    }, textarea, renderNumberMark()) : textarea;
  };

  return /*#__PURE__*/React.createElement(ClearableInput, _extends({}, textAreaProps, {
    handleReset: handleReset,
    value: value,
    inputType: "text",
    prefixCls: textAreaPrefixCls,
    element: renderTextArea(textAreaPrefixCls),
    numberMark: renderNumberMark()
  }));
};

var TextArea = /*#__PURE__*/React.forwardRef(InternalTextarea);
TextArea.displayName = 'TextArea';
export default TextArea;